module.exports = __webpack_public_path__ + "img/229.weekly_cleaning.4d68608d.svg";